import * as React from 'react';
import { AdminHeader } from 'components/PortalStructure';
import { setInitialData } from 'modules/user/userpreferences';
import { IUserPreferences } from 'models/user/userpreferences';
import { IStore } from 'redux/IStore';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { AdminSideMenu } from 'components/PortalStructure';
import { IAuthContext, ILanguage } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IUserLanguage } from 'models/user/userlanguage';
const { connect } = require('react-redux');
require('./style.scss');

interface IProps {
	userPreferences?: IUserPreferences;
	dispatch?: any;
	routes?: any;
	context: IAuthContext;
	languageDomainValues?: ILanguage[];
	userLanguage?: IUserLanguage;
	setInitialData?: (isAuthenticated) => void;
	t?: (key: string) => string;
}

@connect(
	(store: IStore) => ({
		userPreferences: store.userPreferences,
		languageDomainValues: store.domainValues.languages,
		userLanguage: store.userLanguage,
	}),
	(dispatch) => ({
		setInitialData: (isAuthenticated: boolean) => dispatch(setInitialData(isAuthenticated)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdministrationBaseLayoutComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.state = { sidebarOpen: false };
	}

	public componentDidMount() {
		const isAuthenticated = this.props.context.isAuthenticated();
		this.props.setInitialData(isAuthenticated as boolean);
	}

	public render() {
		const { userPreferences, routes } = this.props;

		const headerProps = {
			userPreferences,
			routes,
			closeSideBarCallback: () => this.setState((state) => ({ sidebarOpen: !state.sidebarOpen })),
		};

		return (
			<>
				<AdminHeader {...headerProps} />
				<div className="adminContentWrapper">
					<div className={`leftMenu ${this.state.sidebarOpen ? '' : 'closed'}`}>
						<AdminSideMenu
							t={this.props.t}
							closeSideBarCallback={() => this.setState((state) => ({ sidebarOpen: !state.sidebarOpen }))}
							sidebarOpen={this.state.sidebarOpen}
						/>
					</div>
					<div className="content">{this.props.children}</div>
				</div>
			</>
		);
	}
}
const AdministrationBaseLayout = withAuthContext(AdministrationBaseLayoutComponent);

export { AdministrationBaseLayout };
